import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"calendar-mark--calendar-date-day-month-mark\"><path id=\"Rectangle 11\" d=\"M1.30469 2.74463H19.3047V18.9446H1.30469V2.74463Z\" stroke=\"#454342\" stroke-width=\"1.5\"></path><path id=\"Vector 38\" d=\"M1.30469 6.34619H19.3047\" stroke=\"#454342\" stroke-width=\"1.5\"></path><path id=\"Vector 39\" d=\"M4.90625 0.0454102V2.74541\" stroke=\"#454342\" stroke-width=\"1.5\"></path><path id=\"Vector 40\" d=\"M15.7031 0.0454102V2.74541\" stroke=\"#454342\" stroke-width=\"1.5\"></path></g>", 1)
  ])))
}
export default { render: render }